import React, { useState, useEffect, useMemo } from 'react';

import axios from 'axios';
import swal from 'sweetalert';
import { Pagination } from "antd";

import { getCookie } from '../common_component/cookie.js';
import { useAuthData } from "./auth-provider.js"
import PageError from '../common_component/PageError.js';
import StatusBadge from "../common_component/StatusBadge.js";
import { useModal } from '../providers/modal-provider.js';

export const CurrencyList = () => {
    const [state, setstate] = useState(2);
    const [currencyList, setCurrencyList] = useState([]);

    const [currentPage, setCurrentPage] = useState(1)
    const [rowsPerPage, setRowsPerPage] = useState(10)
    const [searchValue, setSearchValue] = useState(null)

    const { openModal, setModalView, setModalData } = useModal()

    var page_name = "currency-list";

    const { user, read, write, visibility, organization_id, user_role } = useAuthData(page_name)

    const loaderstyle = {
        display: "block",
        marginLeft: "auto",
        marginRight: "auto",
        marginTop: "auto",
        marginBottom: "auto",
    };

    async function getCurrencyList() {
        const response = await fetch(
            `${process.env.REACT_APP_SERVER_URL}/currency-datatable`, { method: 'POST', body: JSON.stringify({ "email": user.email, "page_name": page_name, "organization_id": organization_id }), headers: { "Content-type": "application/json; charset=UTF-8", "token": getCookie("access_token") } }
        );
        const body = await response.json();

        if (body.operation === "success") {
            setstate(1);
            setCurrencyList(body.data);
        }
        else {
            setstate(0);
        }
    }

    useEffect(() => {
        if ((read || write) && (user.email && visibility)) {
            getCurrencyList();
        }
    }, [user, visibility, read, write])

    const updateStatus = (currency_id, status) => {
        let values = { "id": currency_id, "status": status, "page_name": page_name, "organization_id": organization_id };

        var headers = {
            headers: {
                "Content-Type": "application/json",
                "Accept": "*/*",
                "token": getCookie("access_token")
            }
        }

        axios.post(`${process.env.REACT_APP_SERVER_URL}/update-status-currency`, values, headers).then((res) => {
            if (res.data && res.data.operation == "success") {
                getCurrencyList()

                swal("Great!", "Currency details deleted successfully!", "success")
            }
            else {
                swal("Oops!", "Something went wrong!", "error");
            }
        });
    }

    const filteredList = useMemo(() => {
        if (searchValue) {
            return currencyList.filter((x) => {
                let r = new RegExp(searchValue, "gi")
                return r.test(x.currency_code) || r.test(x.currency_symbol)
            })
        }
        else {
            return currencyList
        }
    }, [currencyList, searchValue])

    return (
        <>
            <div>
                <div className="d-flex flex-stack">
                    <h1 className="page-heading d-flex text-dark fw-bold fs-3 flex-column justify-content-center my-0">Currency List</h1>
                    <div className="d-flex align-items-center gap-2 gap-lg-3">
                        {
                            write &&
                            <button className="btn btn-sm btn-primary btn-hover-scale"
                                onClick={() => {
                                    setModalData({
                                        apiCallback: () => { getCurrencyList(); },
                                        page_name,
                                    })
                                    setModalView("CURRENCY_MODAL")
                                    openModal()
                                }}
                            >New Currency</button>
                        }
                    </div>
                </div>
                <div>
                    {
                        state === 1 ?
                            <>
                                <div className="card mb-5 mb-xl-8">
                                    <div className="card-body py-3">
                                        <div className='mb-5'>
                                            <input type="text" className='form-control fw-bold border border-primary' value={searchValue || ""} onChange={(e) => { setCurrentPage(1); setSearchValue(e.target.value) }} placeholder='Search...' />
                                        </div>

                                        <div className="mb-5 d-flex justify-content-center">
                                            <Pagination
                                                total={filteredList.length}
                                                onChange={(page, pageSize) => {
                                                    setCurrentPage(page);
                                                    if (pageSize !== rowsPerPage) {
                                                        setCurrentPage(1);
                                                    }
                                                    setRowsPerPage(pageSize);
                                                }}
                                                showTotal={(total, range) => `${range[0]} - ${range[1]} of ${total} items`}
                                                showQuickJumper={true}
                                                pageSize={rowsPerPage}
                                                current={currentPage}
                                                showSizeChanger={true}
                                            />
                                        </div>
                                        <div className='overflow-auto'>
                                            <table className="table table-row-bordered table-row-gray-100 align-middle gs-0 gy-3 h-preserve-whitespace" style={{ minWidth: "1000px" }} >
                                                <thead>
                                                    <tr className="fw-bold text-muted">
                                                        <th className="min-w-150px">Currency Name</th>
                                                        <th className="min-w-150px">Symbol</th>
                                                        <th className="min-w-150px">Status</th>
                                                        <th className="min-w-50px text-end">Actions</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {
                                                        filteredList.length > 0 ?
                                                            filteredList.slice((currentPage - 1) * rowsPerPage, (currentPage - 1) * rowsPerPage + rowsPerPage).map((obj) => {
                                                                return (
                                                                    <tr key={obj.currency_id}>
                                                                        <td>
                                                                            <span className="text-dark fw-bold text-hover-primary me-5 mb-1 fs-6">{obj.currency_code}</span>
                                                                            {obj.default_currency === 1 && <span className='badge badge-primary'>DEFAULT</span>}
                                                                        </td>
                                                                        <td><span className="badge badge-light-info">{obj.currency_symbol}</span></td>
                                                                        <td><StatusBadge status={obj.status} entity={""} /></td>
                                                                        <td className="text-end">
                                                                            <div className="dropdown" style={{ position: "unset" }}>
                                                                                <button className="btn btn-sm btn-secondary rounded" type="button" id="dropdownMenuButton1" data-bs-toggle="dropdown" aria-expanded="false"><i className="fas fa-bars px-0"></i></button>
                                                                                {
                                                                                    write &&
                                                                                    <ul className="dropdown-menu" aria-labelledby="dropdownMenuButton1">
                                                                                        <li>
                                                                                            <span className="dropdown-item cursor-pointer" onClick={() => {
                                                                                                setModalData({
                                                                                                    apiCallback: () => { getCurrencyList(); },
                                                                                                    currencyData: obj,
                                                                                                    updateMode: true,
                                                                                                    ...(obj.default_currency === 1 ? { disabledFields: ["currency_code"] } : []),
                                                                                                    page_name,
                                                                                                })
                                                                                                setModalView("CURRENCY_MODAL")
                                                                                                openModal()
                                                                                            }} >Edit details</span>
                                                                                        </li>
                                                                                        <li>
                                                                                            <span className="dropdown-item cursor-pointer" onClick={() => {
                                                                                                swal({
                                                                                                    title: `Are you sure? Current Status: ${obj.status}`,
                                                                                                    icon: "warning",
                                                                                                    buttons: true,
                                                                                                    dangerMode: true,
                                                                                                })
                                                                                                    .then((val) => {
                                                                                                        if (val) {
                                                                                                            updateStatus(obj.currency_id, obj.status === "Active" ? "Deactivated" : "Active")
                                                                                                        }
                                                                                                    })
                                                                                            }} >Change Status</span>
                                                                                        </li>
                                                                                    </ul>
                                                                                }
                                                                            </div>
                                                                        </td>
                                                                    </tr>
                                                                )
                                                            })
                                                            :
                                                            <tr>
                                                                <td colSpan={4} className="text-center">
                                                                    <h3 className="text-muted pt-6">No data to be shown</h3>
                                                                </td>
                                                            </tr>
                                                    }
                                                </tbody>
                                            </table>
                                        </div>

                                        <div className="mt-5 d-flex justify-content-center">
                                            <Pagination
                                                total={filteredList.length}
                                                onChange={(page, pageSize) => {
                                                    setCurrentPage(page);
                                                    if (pageSize !== rowsPerPage) {
                                                        setCurrentPage(1);
                                                    }
                                                    setRowsPerPage(pageSize);
                                                }}
                                                showTotal={(total, range) => `${range[0]} - ${range[1]} of ${total} items`}
                                                pageSize={rowsPerPage}
                                                current={currentPage}
                                                showSizeChanger={true}
                                                showQuickJumper={true}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </>
                            :
                            state === 2 ?
                                <img src="/images/loader-06.svg" alt="" style={loaderstyle} />
                                :
                                <PageError />
                    }
                </div>
            </div>
        </>
    )
};

export default CurrencyList;
